'use strict';

angular.module('ringbaPortal')
  .filter('secondsDisplayFormat', ['timeFormatService', function (timeFormatService) {
    return function (value, showTillMinutes) {
      return timeFormatService.secondsToDisplay(value, showTillMinutes);
    };
  }]);